/* INTEGY V298 - canonical filter taxonomy + fast collection loading - 26JUN2026
   One authoritative filter-availability owner. V298 groups customer-facing part
   aliases before availability checks, chooses a verified Shopify tag URL for each
   canonical group, and avoids repeated browser work by caching local/index/live
   decisions. Search, product cards, grid, header, cart, and product pages are
   intentionally outside this file. */
(function () {
  'use strict';


  function indexedCanonicalCollectionPath() {
    if (!window.INTEGY_V305_FILTER_INDEX_FINAL && !window.INTEGY_V306_FILTER_INDEX_COVERAGE && !window.INTEGY_V307_CANONICAL_INDEX_REBUILD) return false;
    var parts = String(location.pathname || '').split('/').filter(Boolean);
    var index = parts.indexOf('collections');
    var handle = index >= 0 && parts[index + 1] ? parts[index + 1].toLowerCase() : '';
    handle = handle.replace(/[^a-z0-9-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    return {
      'hop-up-parts-for-traxxas': true,
      'hopups-for-traxxas': true,
      'parts-for-traxxas': true,
      'hopups-for-axial': true,
      'hop-up-parts-for-axial': true,
      'parts-for-axial': true,
      'hop-up-parts-for-hpi-racing': true,
      'hopups-for-hpi-racing': true,
      'parts-for-hpi-racing': true,
      'parts-for-hpi': true,
      'hopups-for-arrma': true,
      'hop-up-parts-for-arrma': true,
      'parts-for-arrma': true,
      'arrma': true,
      'hopups-for-tamiya': true,
      'hop-up-parts-for-tamiya': true,
      'parts-for-tamiya': true,
      'tamiya': true,
      'hopups-for-losi': true,
      'hop-up-parts-for-losi': true,
      'parts-for-losi': true,
      'losi': true,
      'all-integy-hop-up-parts': true,
      'rc-tools': true,
      'all-rc-tools-tool-sets-and-accessories': true,
      'rc-electronics': true,
      'cars-trucks': true,
      'tesla-accessories': true,
      'tires-wheels-hex-inserts-for-rc-cars-trucks': true,
      'pinion-gears-for-rc': true,
      'pinion-gears-for-rc-cars-and-trucks': true,
      'pinion-gears-for-rc-cars-trucks': true
    }[handle] === true;
  }

  if (indexedCanonicalCollectionPath()) return;

  if (!window.INTEGY_V295_FILTER_SINGLE_OWNER || window.IntegyV298Filters || window.IntegyV297Filters || window.IntegyV295Filters) return;

  var v302Taxonomy = !!window.INTEGY_V302_NORMALIZED_TAXONOMY;
  if (!window.INTEGY_V300_MOBILE_PERFORMANCE && !v302Taxonomy) {
  }
  var root = document.documentElement;
  root.classList.add('integy-v294-filter-owner', 'integy-v295-filter-owner', 'integy-v297-filter-owner', 'integy-v298-filter-owner');
  if (v302Taxonomy) root.classList.add('integy-v302-normalized-filter-owner');

  var lowPower = false;
  try {
    lowPower = !!(
      (navigator.connection && navigator.connection.saveData) ||
      (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
      (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    );
  } catch (error) {}
  root.classList.toggle('integy-v295-low-power', lowPower);
  root.classList.toggle('integy-v297-low-power', lowPower);
  root.classList.toggle('integy-v298-low-power', lowPower);

  function deferWork(callback) {
    return new Promise(function (resolve) {
      function run() {
        Promise.resolve().then(callback).then(resolve).catch(function () { resolve(false); });
      }
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: lowPower ? 900 : 450 });
      } else {
        setTimeout(run, lowPower ? 90 : 24);
      }
    });
  }

  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }

  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function handleize(value) {
    value = clean(value).toLowerCase();
    try { value = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return value
      .replace(/&/g, ' and ')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function titleize(handle) {
    var special = {
      rc: 'RC', esc: 'ESC', led: 'LED', hpi: 'HPI', rtr: 'RTR', artr: 'ARTR',
      trx: 'TRX', dbxl: 'DBXL', lcg: 'LCG', xrt: 'XRT', scx: 'SCX',
      m3: 'M3', m4: 'M4', m5: 'M5'
    };
    return String(handle || '').split('-').filter(Boolean).map(function (part) {
      return special[part] || part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function makeMap(values) {
    var map = Object.create(null);
    (values || []).forEach(function (value) { map[handleize(value)] = true; });
    return map;
  }

  function mergeMaps() {
    var output = Object.create(null);
    Array.prototype.slice.call(arguments).forEach(function (map) {
      Object.keys(map || {}).forEach(function (key) { output[key] = true; });
    });
    return output;
  }

  function unique(values) {
    var seen = Object.create(null);
    var output = [];
    (values || []).forEach(function (value) {
      value = handleize(value);
      if (value && !seen[value]) {
        seen[value] = true;
        output.push(value);
      }
    });
    return output;
  }

  var queryFilterCollections = {
    'rc-tools': true,
    'all-rc-tools-tool-sets-and-accessories': true,
    'tires-wheels-hex-inserts-for-rc-cars-trucks': true
  };


  /* V439: six specialist collections use a strict profile instead of the
     universal RC-parts taxonomy. Missing local-index tags are live-probed,
     so zero-result options are removed before they are shown. */
  var V439_SPECIALTY_ALLOWED = {
    'battery-plugs-meters-accessories-for-rc-cars-boats-planes-helicopters': makeMap([
      'connector','adapter','plug','wire','battery-straps-and-accessories','lipo-battery-bag',
      'meters-and-accessories','voltage-checker-battery-tester','charger','soldering-jig',
      'xt60','xt90','t-plug','ec3','ec5','jst','banana-plug','bullet','clearance'
    ]),
    'servos-digital-servos-for-rc-cars-boats-planes-helicopters': makeMap([
      '1-10','1-7','crawler','drift','touring','rtr','black','blue','red','silver','grey','orange'
    ]),
    'custom-steering-wheels': makeMap([
      'steering-wheel','radio-steering-wheel','futaba','sanwa','airtronics','hitec','flysky',
      'spektrum','black','blue','red','silver','orange','yellow'
    ]),
    'radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters': makeMap([
      'radio','receiver','flysky','futaba','rtr','black','red','gold'
    ]),
    'aluminum-servo-horn-for-rc-cars-boats-planes-helicopters': makeMap([
      'servo-horn','servo-saver','servo-mount','futaba','sanwa','hitec','3racing',
      'black','blue','red','silver','gunmetal','orange','purple','gold','clearance'
    ]),
    'connectors-plugs-wires-for-rc-cars-helicopters-planes': makeMap([
      'connector','plug','wire','adapter','charger','xt60','xt90','t-plug','ec3','ec5','jst',
      'futaba','banana-plug','bullet','clearance'
    ])
  };
  var V439_SPECIALTY_DIRECT = {
    'servos-digital-servos-for-rc-cars-boats-planes-helicopters': [
      { handle:'digital-servo', label:'Digital Servos', href:'/collections/digital-servo' },
      { handle:'high-voltage-servo', label:'High Voltage Servos', href:'/collections/high-voltage-servo' },
      { handle:'brushless-servo', label:'Brushless Servos', href:'/collections/high-voltage-brushless-servo' },
      { handle:'low-profile-servo', label:'Low Profile Servos', href:'/collections/low-profile-servo' },
      { handle:'micro-servo', label:'Micro Servos', href:'/collections/micro-digital-servo' },
      { handle:'high-torque-servo', label:'High Torque Servos', href:'/collections/high-torque-servo' },
      { handle:'crawler-servo', label:'Crawler Servos', href:'/collections/rock-crawler-servo-all-terrain-off-road-vehicles' }
    ]
  };

  function v439SpecialtyAllowed(handle) {
    var profile = V439_SPECIALTY_ALLOWED[currentCollection()];
    return !!(profile && profile[handleize(handle)]);
  }
  function v439SpecialtyCollection() {
    return !!V439_SPECIALTY_ALLOWED[currentCollection()];
  }

  function queryFilterCollection(handle) {
    handle = handleize(handle);
    return !!queryFilterCollections[handle];
  }

  function queryFilterTags(search) {
    try {
      var params = new URLSearchParams(typeof search === 'string' ? search : (location.search || ''));
      var raw = params.get('integy_filter') || params.get('integy_filters') || params.get('integy_tag_filter') || '';
      raw = String(raw || '').replace(/\s+/g, '+');
      return raw ? unique(raw.split('+')) : [];
    } catch (error) {
      return [];
    }
  }

  function pathData(path) {
    var value = String(path || location.pathname || '');
    var parsedSearch = '';
    try {
      var parsed = new URL(value, location.origin);
      parsedSearch = parsed.search || '';
      value = parsed.pathname;
    } catch (error) {}
    var parts = value.split('/').filter(Boolean);
    var index = parts.indexOf('collections');
    var collection = index >= 0 && parts[index + 1] ? handleize(decodeURIComponent(parts[index + 1])) : '';
    var useCurrentQuery = !path || value === location.pathname;
    var queryTags = queryFilterTags(parsedSearch || (useCurrentQuery ? location.search : ''));
    return {
      collection: collection,
      tags: queryTags.length
        ? queryTags
        : (index >= 0 && parts[index + 2]
          ? unique(decodeURIComponent(parts.slice(index + 2).join('/')).split('+'))
          : [])
    };
  }

  function currentCollection() {
    return pathData(location.pathname).collection;
  }

  function currentTags() {
    return pathData(location.pathname).tags;
  }

  function cleanQuery() {
    try {
      var params = new URLSearchParams(location.search || '');
      ['page', 'view', 'grid_list', 'integy_vehicle_filter', 'integy_filter', 'integy_filters', 'integy_tag_filter'].forEach(function (key) { params.delete(key); });
      var value = params.toString();
      return value ? '?' + value : '';
    } catch (error) {
      return '';
    }
  }

  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function buildUrl(collection, tags) {
    collection = handleize(collection);
    tags = unique(tags);
    if (queryFilterCollection(collection)) {
      var extra = cleanQuery();
      if (tags.length) {
        return v626RootPath() + 'collections/' + collection + '?integy_filter=' + tags.map(encodeURIComponent).join('%2B') + (extra ? '&' + extra.replace(/^\?/, '') : '');
      }
      return v626RootPath() + 'collections/' + collection + extra;
    }
    return v626RootPath() + 'collections/' + collection + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '') + cleanQuery();
  }

  function tagsWithout(tags, handle) {
    var family = canonical(handle);
    return unique(tags).filter(function (tag) { return canonical(tag) !== family; });
  }

  var COLORS = makeMap([
    'black', 'blue', 'red', 'green', 'silver', 'grey', 'gray', 'gunmetal',
    'orange', 'purple', 'pink', 'yellow', 'gold', 'white', 'brown', 'bronze',
    'clear', 'smoke', 'chrome', 'titanium', 'natural', 'light-blue'
  ]);

  var GENERIC_BLOCK = makeMap([
    'mount', 'mounts', 'chassis', 'suspension', 'link', 'links', 'rod', 'rods',
    'shaft', 'shafts', 'box', 'boxes', 'universal', 'universals', 'pin', 'pins',
    'hinge-pin', 'hinge-pins', 'nut', 'nuts', 'wheel-nut', 'wheel-nuts',
    'screw', 'screws', 'washer', 'washers', 'spacer', 'spacers', 'shim', 'shims',
    'glue', 'glues', 'tape', 'tapes', 'decal', 'decals', 'discharger',
    'dischargers', 'power-supply', 'power-supplies', 'boat', 'boats', 'rc-boat',
    'rc-boats', 'rc-truck', 'rc-trucks', 'all-terrain', '4wd', '6x6', '8x8',
    'suspension-hanger', 'suspension-hangers', 'body', 'bodies', 'tower', 'towers'
  ]);

  var WHEELS_ALLOWED = mergeMaps(COLORS, makeMap([
    'wheel', 'wheels', 'tire', 'tires', 'wheel-hex', 'wheel-hexes',
    'wheel-hex-hub', 'wheel-hex-hubs'
  ]));

  var ELECTRONICS_ALLOWED = mergeMaps(COLORS, makeMap([
    'motor', 'motors', 'esc', 'escs', 'servo', 'servos', 'servo-horn',
    'servo-horns', 'servo-mount', 'servo-mounts', 'motor-mount', 'motor-mounts',
    'fan', 'fans', 'cooling-fan', 'cooling-fans', 'heatsink', 'heat-sink',
    'battery', 'batteries', 'charger', 'chargers', 'connector', 'connectors',
    'plug', 'plugs', 'wire', 'wires', 'radio', 'radios', 'receiver-box',
    'receiver-boxes'
  ]));

  var TOOLS_ALLOWED = mergeMaps(COLORS, makeMap([
    'tool', 'tools', 'wrench', 'wrenches', 'driver', 'drivers', 'turnbuckle',
    'turnbuckles', 'shock', 'shocks', 'wheel-hex', 'wheel-hex-hub'
  ]));

  var BOATS_ALLOWED = mergeMaps(COLORS, makeMap([
    'rtr', 'artr', 'kit', 'boat-kit', 'boat-kits', 'hull', 'hulls',
    'catamaran', 'mono-hull', 'monohull', 'jet-boat', 'jet-boats',
    'marine-esc', 'esc', 'brushless-motor', 'brushed-motor', 'motor-mount',
    'water-cooling', 'water-cooler', 'cooling-jacket', 'cooling-tube',
    'pump', 'propeller', 'propellers', 'jet-drive', 'jet-drives', 'outdrive',
    'outdrives', 'drive-shaft', 'drive-shafts', 'coupler', 'couplers',
    'stuffing-tube', 'stuffing-tubes', 'rudder', 'rudders', 'trim-tab',
    'trim-tabs', 'receiver-box', 'receiver-boxes', 'servo-horn', 'servo-horns',
    'linkage', 'led-light', 'led-lights', 'battery-strap', 'battery-straps',
    'seal', 'boot', 'hardware', 'maintenance-tool', 'prop-balancer',
    'rc-boat', 'rc-boats-and-parts', 'boats-and-parts'
  ]));

  var SUSPENSION_ALLOWED = mergeMaps(COLORS, makeMap([
    'shock', 'shocks', 'shock-tower', 'shock-towers', 'spring', 'springs',
    'suspension-arm', 'suspension-arms', 'steering-block', 'steering-blocks',
    'steering-knuckle', 'steering-knuckles', 'caster-block', 'caster-blocks', 'hub-carrier', 'hub-carriers',
    'turnbuckle', 'turnbuckles', 'rod-end', 'rod-ends', 'ball-end', 'ball-ends',
    'tie-rod', 'tie-rods', 'tie-rod-end', 'tie-rod-ends', 'ball-link', 'ball-links',
    'bearing', 'bearings', 'brace', 'braces', 'servo-saver', 'servo-savers',
    'skid-plate', 'skid-plates', 'drive-shaft', 'drive-shafts', 'cvd', 'dogbone',
    'suspension-link', 'suspension-links', 'suspension-kit', 'suspension-kits',
    'suspension-conversion-kit', 'suspension-conversion-kits'
  ]));

  var BRAND_ALLOWED = mergeMaps(COLORS, makeMap([
    'wheel', 'wheels', 'tire', 'tires', 'wheel-hex', 'wheel-hex-hub',
    'shock', 'shocks', 'shock-tower', 'shock-towers', 'spring', 'springs',
    'suspension-arm', 'suspension-arms', 'steering-block', 'steering-blocks',
    'caster-block', 'caster-blocks', 'hub-carrier', 'hub-carriers',
    'drive-shaft', 'drive-shafts', 'gear', 'gears', 'pinion-gear',
    'pinion-gears', 'spur-gear', 'spur-gears', 'bearing', 'bearings',
    'servo', 'servos', 'servo-horn', 'servo-horns', 'servo-mount',
    'servo-mounts', 'esc', 'motor', 'motors', 'motor-mount', 'motor-mounts',
    'cooling-fan', 'cooling-fans', 'fan', 'fans', 'heatsink', 'heat-sink',
    'bumper', 'bumpers', 'rc-body', 'rc-bodies', 'body-mount', 'body-mounts',
    'body-post', 'body-posts', 'turnbuckle', 'turnbuckles', 'rod-end',
    'rod-ends', 'tie-rod', 'tie-rods', 'tie-rod-end', 'tie-rod-ends',
    'ball-end', 'ball-ends', 'ball-link', 'ball-links', 'skid-plate', 'skid-plates',
    'connector', 'connectors', 'plug', 'plugs', 'wire', 'wires', 'battery',
    'batteries', 'charger', 'chargers', 'tool', 'tools', 'wrench', 'wrenches',
    'receiver-box', 'receiver-boxes', 'brace', 'braces', 'steering-knuckle',
    'steering-knuckles', 'servo-saver', 'servo-savers', 'battery-plate',
    'battery-plates', 'battery-tray', 'battery-trays', 'gearbox', 'gearboxes',
    'gearbox-cover', 'gearbox-covers', 'gear-set', 'gear-sets', 'suspension-link',
    'suspension-links', 'suspension-kit', 'suspension-kits',
    'suspension-conversion-kit', 'suspension-conversion-kits',
    'setup-station', 'setup-stations', 'bellcrank', 'bellcranks', 'top-plate',
    'top-plates', 'bumper-guard', 'bumper-guards', 'body-post-tower',
    'body-post-towers', 'body-post-extender', 'body-post-extenders',
    'axle-carrier', 'axle-carriers', 'dogbone', 'dogbones', 'cvd'
  ]));

  var GENERAL_ALLOWED = mergeMaps(BRAND_ALLOWED, makeMap([
    'radio', 'radios', 'driver', 'drivers'
  ]));

  var MODEL_PART_PROBES = [
    'brace', 'motor-mount', 'steering-block', 'steering-knuckle', 'servo-saver', 'hub-carrier',
    'battery-plate', 'battery-tray', 'gearbox', 'gearbox-cover', 'rc-body',
    'body-mount', 'body-post', 'skid-plate', 'pinion-gear', 'spur-gear',
    'gear-set', 'shock', 'shock-tower', 'suspension-arm', 'suspension-link',
    'suspension-kit', 'suspension-conversion-kit', 'setup-station',
    'bellcrank', 'top-plate', 'bumper-guard', 'rod-end', 'tie-rod-end',
    'ball-end', 'drive-shaft'
  ];

  var CANONICAL = {
    wheels: 'wheel', tires: 'tire', shocks: 'shock', 'shock-towers': 'shock-tower',
    springs: 'spring', 'suspension-arms': 'suspension-arm',
    'steering-blocks': 'steering-block', 'caster-blocks': 'caster-block',
    'hub-carriers': 'hub-carrier', 'drive-shafts': 'drive-shaft', gears: 'gear',
    'pinion-gears': 'pinion-gear', 'spur-gears': 'spur-gear', bearings: 'bearing',
    servos: 'servo', 'servo-horns': 'servo-horn', 'servo-mounts': 'servo-mount',
    motors: 'motor', 'motor-mounts': 'motor-mount', 'cooling-fans': 'cooling-fan',
    fans: 'fan', bumpers: 'bumper', 'rc-bodies': 'rc-body',
    'body-mounts': 'body-mount', 'body-posts': 'body-post',
    turnbuckles: 'turnbuckle', 'rod-ends': 'rod-end', 'ball-ends': 'ball-end',
    'skid-plates': 'skid-plate', connectors: 'connector', plugs: 'plug',
    wires: 'wire', batteries: 'battery', chargers: 'charger', tools: 'tool',
    wrenches: 'wrench', drivers: 'driver', 'receiver-boxes': 'receiver-box',
    braces: 'brace', 'steering-knuckles': 'steering-knuckle',
    'servo-savers': 'servo-saver', 'battery-plates': 'battery-plate',
    'battery-trays': 'battery-tray', gearboxes: 'gearbox',
    'gearbox-covers': 'gearbox-cover', 'suspension-kits': 'suspension-kit',
    'setup-stations': 'setup-station', bellcranks: 'bellcrank',
    'top-plates': 'top-plate', 'bumper-guards': 'bumper-guard',
    grays: 'grey', gray: 'grey', 'heat-sink': 'heatsink',
    'wheel-hexes': 'wheel-hex', 'wheel-hex-hubs': 'wheel-hex-hub'
  };

  var CANONICAL_GROUPS = {
    'rod-end': {
      label: 'Rod End / Tie Rod',
      preferred: ['rod-end', 'tie-rod-end', 'tie-rod', 'ball-end', 'ball-link', 'turnbuckle-end', 'turnbuckle'],
      aliases: [
        'rod-end', 'rod-ends', 'tie-rod-end', 'tie-rod-ends', 'tie-rod', 'tie-rods',
        'ball-end', 'ball-ends', 'ball-link', 'ball-links', 'turnbuckle-end',
        'turnbuckle-ends', 'turnbuckles-rod-ends', 'turnbuckles-and-rod-ends'
      ],
      exclude: ['tool', 'tools', 'wrench', 'wrenches', 'driver', 'drivers', 'adapter', 'adapters']
    },
    'shock-tower': {
      label: 'Shock Tower',
      preferred: ['shock-tower', 'front-shock-tower', 'rear-shock-tower', 'shock-mount-tower'],
      aliases: ['shock-tower', 'shock-towers', 'front-shock-tower', 'rear-shock-tower', 'shock-mount-tower', 'shock-mount-towers']
    },
    'body-mount': {
      label: 'Body Mount / Body Post',
      preferred: ['body-mount', 'body-post', 'body-post-tower', 'body-post-extender'],
      aliases: [
        'body-mount', 'body-mounts', 'body-post', 'body-posts', 'body-mount-post',
        'body-mounts-posts', 'body-post-tower', 'body-post-towers',
        'body-post-extender', 'body-post-extenders'
      ]
    },
    'rc-body': {
      label: 'RC Body',
      preferred: ['rc-body', 'body-cage', 'body-panel'],
      aliases: ['rc-body', 'rc-bodies', 'body-cage', 'body-cages', 'body-panel', 'body-panels']
    },
    'steering-block': {
      label: 'Steering Block / Knuckle',
      preferred: ['steering-block', 'steering-knuckle', 'c-hub', 'caster-block', 'steering-hub'],
      aliases: [
        'steering-block', 'steering-blocks', 'steering-knuckle', 'steering-knuckles',
        'knuckle', 'knuckles', 'c-hub', 'c-hubs', 'c-hub-carrier', 'c-hub-carriers',
        'caster-block', 'caster-blocks', 'steering-hub', 'steering-hubs'
      ]
    },
    'hub-carrier': {
      label: 'Hub Carrier',
      preferred: ['hub-carrier', 'rear-hub-carrier', 'front-hub-carrier', 'axle-carrier'],
      aliases: ['hub-carrier', 'hub-carriers', 'rear-hub-carrier', 'rear-hub-carriers', 'front-hub-carrier', 'front-hub-carriers', 'axle-carrier', 'axle-carriers']
    },
    'drive-shaft': {
      label: 'Drive Shaft / CVD',
      preferred: ['drive-shaft', 'cvd', 'cvd-drive-shaft', 'dogbone', 'center-drive-shaft'],
      aliases: [
        'drive-shaft', 'drive-shafts', 'driveshaft', 'driveshafts', 'cvd',
        'cvds', 'cvd-drive-shaft', 'cvd-drive-shafts', 'universal-shaft',
        'universal-shafts', 'center-drive-shaft', 'center-drive-shafts',
        'dogbone', 'dogbones', 'dog-bone', 'dog-bones'
      ]
    },
    'pinion-gear': { label: 'Pinion Gear', preferred: ['pinion-gear'], aliases: ['pinion-gear', 'pinion-gears'] },
    'spur-gear': { label: 'Spur Gear', preferred: ['spur-gear'], aliases: ['spur-gear', 'spur-gears'] },
    'gear-set': { label: 'Gear Set', preferred: ['gear-set'], aliases: ['gear-set', 'gear-sets', 'gear-kit', 'gear-kits'] },
    gearbox: { label: 'Gearbox', preferred: ['gearbox'], aliases: ['gearbox', 'gearboxes', 'gear-box', 'gear-boxes'] },
    'gearbox-cover': { label: 'Gearbox Cover', preferred: ['gearbox-cover'], aliases: ['gearbox-cover', 'gearbox-covers', 'gear-cover', 'gear-covers', 'spur-gear-cover', 'spur-gear-covers'] },
    'suspension-arm': { label: 'Suspension Arm', preferred: ['suspension-arm'], aliases: ['suspension-arm', 'suspension-arms', 'a-arm', 'a-arms', 'control-arm', 'control-arms'] },
    'suspension-link': { label: 'Suspension Link', preferred: ['suspension-link'], aliases: ['suspension-link', 'suspension-links'] },
    'suspension-kit': { label: 'Suspension Kit', preferred: ['suspension-kit'], aliases: ['suspension-kit', 'suspension-kits'] },
    'suspension-conversion-kit': { label: 'Suspension Conversion Kit', preferred: ['suspension-conversion-kit'], aliases: ['suspension-conversion-kit', 'suspension-conversion-kits'] },
    'servo-horn': { label: 'Servo Horn', preferred: ['servo-horn'], aliases: ['servo-horn', 'servo-horns'] },
    'servo-saver': { label: 'Servo Saver', preferred: ['servo-saver'], aliases: ['servo-saver', 'servo-savers'] },
    'motor-mount': { label: 'Motor Mount', preferred: ['motor-mount'], aliases: ['motor-mount', 'motor-mounts', 'engine-mount', 'engine-mounts'] },
    'battery-plate': { label: 'Battery Plate', preferred: ['battery-plate', 'battery-tray'], aliases: ['battery-plate', 'battery-plates', 'battery-tray', 'battery-trays'] },
    brace: { label: 'Brace', preferred: ['brace'], aliases: ['brace', 'braces'] },
    'skid-plate': { label: 'Skid Plate', preferred: ['skid-plate'], aliases: ['skid-plate', 'skid-plates'] },
    'setup-station': { label: 'Setup Station', preferred: ['setup-station'], aliases: ['setup-station', 'setup-stations'] }
  };

  var V302_GROUP_PATCHES = {
    'rod-end': {
      label: 'Rod End / Ball Link',
      category: 'suspension',
      preferred: ['rod-end', 'ball-end', 'ball-link', 'tie-rod-end'],
      aliases: ['rod-end', 'rod-ends', 'ball-end', 'ball-ends', 'ball-link', 'ball-links', 'tie-rod-end', 'tie-rod-ends'],
      exclude: ['tool', 'tools', 'wrench', 'wrenches', 'driver', 'drivers', 'adapter', 'adapters']
    },
    'tie-rod': { label: 'Tie Rod', category: 'steering', preferred: ['tie-rod'], aliases: ['tie-rod', 'tie-rods', 'drag-link', 'drag-links'] },
    turnbuckle: {
      label: 'Turnbuckle / Linkage',
      category: 'steering',
      preferred: ['turnbuckle', 'turnbuckles-and-rod-ends', 'turnbuckles-rod-ends'],
      aliases: ['turnbuckle', 'turnbuckles', 'turnbuckle-link', 'turnbuckle-links', 'turnbuckles-and-rod-ends', 'turnbuckles-rod-ends']
    },
    linkage: { label: 'Linkage', category: 'steering', preferred: ['linkage'], aliases: ['linkage', 'linkages', 'link-set', 'link-sets'], exclude: ['suspension-link', 'steering-link', 'camber-link'] },
    'suspension-link': { label: 'Suspension Link', category: 'suspension', preferred: ['suspension-link'], aliases: ['suspension-link', 'suspension-links', 'lower-link', 'lower-links', 'upper-link', 'upper-links'] },
    'steering-link': { label: 'Steering Link', category: 'steering', preferred: ['steering-link'], aliases: ['steering-link', 'steering-links'] },
    'camber-link': { label: 'Camber Link', category: 'suspension', preferred: ['camber-link'], aliases: ['camber-link', 'camber-links'] },
    shock: {
      label: 'Shock',
      category: 'suspension',
      preferred: ['shock', 'shocks', 'shock-set'],
      aliases: ['shock', 'shocks', 'shock-set', 'shock-sets', 'damper', 'dampers'],
      exclude: ['shock-tower', 'shock-towers', 'shock-shaft', 'shock-shafts', 'shock-spring', 'shock-springs', 'shock-cap', 'shock-caps', 'shock-tool', 'shock-tools']
    },
    'shock-shaft': { label: 'Shock Shaft', category: 'suspension', preferred: ['shock-shaft'], aliases: ['shock-shaft', 'shock-shafts'] },
    'shock-spring': { label: 'Shock Spring', category: 'suspension', preferred: ['shock-spring', 'spring'], aliases: ['shock-spring', 'shock-springs', 'spring', 'springs'] },
    'shock-tower': { label: 'Shock Tower', category: 'suspension', preferred: ['shock-tower', 'front-shock-tower', 'rear-shock-tower', 'shock-mount-tower'], aliases: ['shock-tower', 'shock-towers', 'front-shock-tower', 'rear-shock-tower', 'shock-mount-tower', 'shock-mount-towers'] },
    'shock-cap': { label: 'Shock Cap', category: 'suspension', preferred: ['shock-cap'], aliases: ['shock-cap', 'shock-caps'] },
    'suspension-arm': { label: 'Suspension Arm', category: 'suspension', preferred: ['suspension-arm'], aliases: ['suspension-arm', 'suspension-arms', 'a-arm', 'a-arms', 'control-arm', 'control-arms'] },
    'arm-mount': { label: 'Arm Mount', category: 'suspension', preferred: ['arm-mount', 'suspension-arm-mount'], aliases: ['arm-mount', 'arm-mounts', 'suspension-arm-mount', 'suspension-arm-mounts'] },
    'hinge-pin': { label: 'Hinge Pin', category: 'suspension', preferred: ['hinge-pin'], aliases: ['hinge-pin', 'hinge-pins'], exclude: ['pin', 'pins'] },
    'hub-carrier': { label: 'Hub Carrier', category: 'suspension', preferred: ['hub-carrier', 'rear-hub-carrier', 'front-hub-carrier', 'axle-carrier'], aliases: ['hub-carrier', 'hub-carriers', 'rear-hub-carrier', 'rear-hub-carriers', 'front-hub-carrier', 'front-hub-carriers', 'axle-carrier', 'axle-carriers'] },
    'caster-block': { label: 'Caster Block', category: 'steering', preferred: ['caster-block', 'c-hub'], aliases: ['caster-block', 'caster-blocks', 'c-hub', 'c-hubs', 'c-hub-carrier', 'c-hub-carriers'] },
    knuckle: { label: 'Knuckle / Steering Block', category: 'steering', preferred: ['knuckle', 'steering-block', 'steering-knuckle'], aliases: ['knuckle', 'knuckles', 'steering-block', 'steering-blocks', 'steering-knuckle', 'steering-knuckles', 'steering-hub', 'steering-hubs'] },
    'steering-block': { label: 'Knuckle / Steering Block', category: 'steering', preferred: ['steering-block', 'steering-knuckle', 'knuckle'], aliases: ['steering-block', 'steering-blocks', 'steering-knuckle', 'steering-knuckles', 'knuckle', 'knuckles', 'steering-hub', 'steering-hubs'] },
    'servo-horn': { label: 'Servo Horn', category: 'steering', preferred: ['servo-horn'], aliases: ['servo-horn', 'servo-horns'] },
    'servo-saver': { label: 'Servo Saver', category: 'steering', preferred: ['servo-saver'], aliases: ['servo-saver', 'servo-savers'] },
    gear: { label: 'Gear', category: 'drivetrain', preferred: ['gear', 'gear-set'], aliases: ['gear', 'gears', 'gear-set', 'gear-sets', 'gear-kit', 'gear-kits'], exclude: ['pinion-gear', 'spur-gear', 'gearbox', 'gearbox-cover', 'differential'] },
    'pinion-gear': { label: 'Pinion Gear', category: 'drivetrain', preferred: ['pinion-gear'], aliases: ['pinion-gear', 'pinion-gears', 'pinion'] },
    'spur-gear': { label: 'Spur Gear', category: 'drivetrain', preferred: ['spur-gear'], aliases: ['spur-gear', 'spur-gears'] },
    gearbox: { label: 'Gearbox / Transmission Case', category: 'drivetrain', preferred: ['gearbox', 'transmission-case'], aliases: ['gearbox', 'gearboxes', 'gear-box', 'gear-boxes', 'transmission-case', 'transmission-cases'] },
    differential: { label: 'Differential', category: 'drivetrain', preferred: ['differential'], aliases: ['differential', 'differentials', 'diff', 'diffs'] },
    'drive-shaft': { label: 'Drive Shaft / CVD', category: 'drivetrain', preferred: ['drive-shaft', 'cvd', 'cvd-drive-shaft', 'dogbone', 'center-drive-shaft'], aliases: ['drive-shaft', 'drive-shafts', 'driveshaft', 'driveshafts', 'cvd', 'cvds', 'cvd-drive-shaft', 'cvd-drive-shafts', 'universal-shaft', 'universal-shafts', 'center-drive-shaft', 'center-drive-shafts', 'dogbone', 'dogbones', 'dog-bone', 'dog-bones'] },
    axle: { label: 'Axle', category: 'drivetrain', preferred: ['axle'], aliases: ['axle', 'axles'] },
    'drive-cup': { label: 'Drive Cup', category: 'drivetrain', preferred: ['drive-cup'], aliases: ['drive-cup', 'drive-cups'] },
    outdrive: { label: 'Outdrive', category: 'drivetrain', preferred: ['outdrive'], aliases: ['outdrive', 'outdrives'] },
    'wheel-hex': { label: 'Wheel Hex / Hex Hub', category: 'wheel', preferred: ['wheel-hex', 'wheel-hex-hub', 'hex-hub'], aliases: ['wheel-hex', 'wheel-hexes', 'wheel-hex-hub', 'wheel-hex-hubs', 'hex-hub', 'hex-hubs', 'hex-wheel-hub', 'hex-wheel-hubs'] },
    'wheel-nut': { label: 'Wheel Nut', category: 'wheel', preferred: ['wheel-nut'], aliases: ['wheel-nut', 'wheel-nuts'] },
    bearing: { label: 'Bearing', category: 'drivetrain', preferred: ['bearing'], aliases: ['bearing', 'bearings'] },
    chassis: { label: 'Chassis', category: 'chassis', preferred: ['chassis'], aliases: ['chassis', 'main-chassis'], exclude: ['chassis-brace'] },
    'chassis-brace': { label: 'Chassis Brace', category: 'chassis', preferred: ['chassis-brace'], aliases: ['chassis-brace', 'chassis-braces', 'brace', 'braces'] },
    'skid-plate': { label: 'Skid Plate', category: 'chassis', preferred: ['skid-plate'], aliases: ['skid-plate', 'skid-plates'] },
    bumper: { label: 'Bumper', category: 'body', preferred: ['bumper'], aliases: ['bumper', 'bumpers', 'bumper-guard', 'bumper-guards'] },
    'body-mount': { label: 'Body Mount / Body Post', category: 'body', preferred: ['body-mount', 'body-post', 'body-post-tower', 'body-post-extender'], aliases: ['body-mount', 'body-mounts', 'body-post', 'body-posts', 'body-mount-post', 'body-mounts-posts', 'body-post-tower', 'body-post-towers', 'body-post-extender', 'body-post-extenders'] },
    'roll-cage': { label: 'Roll Cage', category: 'body', preferred: ['roll-cage'], aliases: ['roll-cage', 'roll-cages', 'body-cage', 'body-cages'] },
    'wing-mount': { label: 'Wing Mount', category: 'body', preferred: ['wing-mount'], aliases: ['wing-mount', 'wing-mounts'] },
    'battery-tray': { label: 'Battery Tray / Plate', category: 'chassis', preferred: ['battery-tray', 'battery-plate'], aliases: ['battery-tray', 'battery-trays', 'battery-plate', 'battery-plates'] },
    'battery-plate': { label: 'Battery Tray / Plate', category: 'chassis', preferred: ['battery-plate', 'battery-tray'], aliases: ['battery-plate', 'battery-plates', 'battery-tray', 'battery-trays'] },
    'motor-mount': { label: 'Motor Mount', category: 'chassis', preferred: ['motor-mount'], aliases: ['motor-mount', 'motor-mounts', 'engine-mount', 'engine-mounts'] },
    tire: { label: 'Tire', category: 'wheel', preferred: ['tire'], aliases: ['tire', 'tires'] },
    wheel: { label: 'Wheel', category: 'wheel', preferred: ['wheel'], aliases: ['wheel', 'wheels'], exclude: ['wheel-hex', 'wheel-nut', 'wheel-adapter', 'beadlock-ring'] },
    'wheel-adapter': { label: 'Wheel Adapter', category: 'wheel', preferred: ['wheel-adapter'], aliases: ['wheel-adapter', 'wheel-adapters', 'offset-adapter', 'offset-adapters', 'wheel-widener', 'wheel-wideners'] },
    'foam-insert': { label: 'Foam Insert', category: 'wheel', preferred: ['foam-insert', 'tire-insert'], aliases: ['foam-insert', 'foam-inserts', 'tire-insert', 'tire-inserts'] },
    'beadlock-ring': { label: 'Beadlock Ring', category: 'wheel', preferred: ['beadlock-ring'], aliases: ['beadlock-ring', 'beadlock-rings', 'bead-lock-ring', 'bead-lock-rings'] },
    'hex-wrench': { label: 'Hex Wrench / Allen Wrench', category: 'tool', preferred: ['hex-wrench', 'allen-wrench'], aliases: ['hex-wrench', 'hex-wrenches', 'allen-wrench', 'allen-wrenches'] },
    'nut-driver': { label: 'Hex Nut Driver / Nut Driver', category: 'tool', preferred: ['nut-driver', 'hex-nut-driver'], aliases: ['nut-driver', 'nut-drivers', 'hex-nut-driver', 'hex-nut-drivers'] },
    screwdriver: { label: 'Screwdriver', category: 'tool', preferred: ['screwdriver'], aliases: ['screwdriver', 'screwdrivers'] },
    'tool-tip': { label: 'Tool Tip / Replacement Tip', category: 'tool', preferred: ['tool-tip'], aliases: ['tool-tip', 'tool-tips', 'replacement-tip', 'replacement-tips'] },
    'shock-tool': { label: 'Shock Tool', category: 'tool', preferred: ['shock-tool'], aliases: ['shock-tool', 'shock-tools', 'shock-shaft-tool', 'shock-shaft-tools'] },
    'led-light': { label: 'LED Light / Light Kit', category: 'electronics', preferred: ['led-light', 'led-light-kit'], aliases: ['led-light', 'led-lights', 'led-light-kit', 'led-light-kits', 'light-kit', 'light-kits'] },
    'light-bar': { label: 'Light Bar', category: 'electronics', preferred: ['light-bar'], aliases: ['light-bar', 'light-bars', 'led-light-bar', 'led-light-bars'] },
    'receiver-box': { label: 'Receiver Box', category: 'electronics', preferred: ['receiver-box'], aliases: ['receiver-box', 'receiver-boxes'] },
    esc: { label: 'ESC', category: 'electronics', preferred: ['esc'], aliases: ['esc', 'escs', 'electronic-speed-control', 'electronic-speed-controls'] },
    motor: { label: 'Motor', category: 'electronics', preferred: ['motor'], aliases: ['motor', 'motors'] },
    servo: { label: 'Servo', category: 'electronics', preferred: ['servo'], aliases: ['servo', 'servos'] },
    fan: { label: 'Fan / Cooling Fan', category: 'electronics', preferred: ['fan', 'cooling-fan'], aliases: ['fan', 'fans', 'cooling-fan', 'cooling-fans'] }
  };

  Object.keys(V302_GROUP_PATCHES).forEach(function (family) {
    CANONICAL_GROUPS[family] = V302_GROUP_PATCHES[family];
  });

  var CANONICAL_ALIAS_TO_GROUP = Object.create(null);
  Object.keys(CANONICAL_GROUPS).forEach(function (family) {
    (CANONICAL_GROUPS[family].aliases || []).forEach(function (alias) {
      CANONICAL_ALIAS_TO_GROUP[handleize(alias)] = family;
    });
  });

  function canonical(handle) {
    handle = handleize(handle);
    return CANONICAL_ALIAS_TO_GROUP[handle] || CANONICAL[handle] || handle;
  }

  function familyCategory(handle) {
    var group = CANONICAL_GROUPS[canonical(handle)];
    return group && group.category ? group.category : '';
  }

  var BRAND_ROOTS = {
    traxxas: 'hop-up-parts-for-traxxas',
    arrma: 'hopups-for-arrma',
    losi: 'hopups-for-losi',
    axial: 'hopups-for-axial',
    hpi: 'hop-up-parts-for-hpi-racing',
    tamiya: 'hopups-for-tamiya',
    associated: 'hopups-for-associated',
    kyosho: 'hop-up-parts-for-kyosho',
    element: 'hopups-for-element',
    redcat: 'hop-up-parts-for-redcat-racing',
    '3racing': 'hop-up-parts-for-3racing'
  };

  var BRAND_COLLECTIONS = makeMap(Object.keys(BRAND_ROOTS).map(function (brand) {
    return BRAND_ROOTS[brand];
  }).concat([
    'hopups-for-traxxas', 'hop-up-parts-for-arrma', 'hop-up-parts-for-losi',
    'hop-up-parts-for-axial-adventure', 'hopups-for-hpi-racing',
    'hop-up-parts-for-tamiya', 'parts-for-traxxas', 'parts-for-arrma',
    'parts-for-losi', 'parts-for-axial', 'parts-for-hpi', 'parts-for-tamiya'
  ]));

  function brandName() {
    var group = qs('[data-integy-static-model-filter-group]');
    var explicit = handleize(group && group.getAttribute('data-integy-brand'));
    if (explicit) return explicit;
    var context = currentCollection();
    var order = ['traxxas', 'arrma', 'losi', 'axial', 'hpi', 'tamiya', 'associated', 'kyosho', 'element', 'redcat', '3racing'];
    for (var index = 0; index < order.length; index += 1) {
      if (context.indexOf(order[index]) !== -1) return order[index];
    }
    return '';
  }

  function brandRoot() {
    var brand = brandName();
    return BRAND_ROOTS[brand] || currentCollection();
  }

  function collectionKind(handle) {
    handle = handleize(handle);
    if (V439_SPECIALTY_ALLOWED[handle]) return 'specialty';
    if (handle === 'tires-wheels-hex-inserts-for-rc-cars-trucks') return 'wheels';
    if (handle === 'rc-electronics') return 'electronics';
    if (handle === 'led-lights') return 'led';
    if (handle === 'rc-tools') return 'tools';
    if (handle === 'boats') return 'boats';
    if (handle === 'suspension-parts') return 'suspension';
    if (BRAND_COLLECTIONS[handle] || qs('[data-integy-static-model-filter-group]') || brandName()) return 'brand';
    return 'general';
  }

  function allowed(handle, kind, active) {
    handle = handleize(handle);
    if (!handle) return false;
    if (active) return true;
    if (kind === 'specialty') return v439SpecialtyAllowed(handle);
    var family = canonical(handle);
    if (COLORS[handle] || COLORS[family]) return true;
    if (GENERIC_BLOCK[handle] && handle === family) return false;
    if (kind === 'boats') return !!(BOATS_ALLOWED[handle] || BOATS_ALLOWED[family]);
    if (v302Taxonomy && CANONICAL_GROUPS[family]) {
      var category = familyCategory(family);
      if (kind === 'wheels') return category === 'wheel' || family === 'bearing';
      if (kind === 'electronics') return category === 'electronics' || family === 'servo-horn' || family === 'servo-saver' || family === 'motor-mount';
      if (kind === 'led') return family === 'led-light' || family === 'light-bar';
      if (kind === 'tools') return category === 'tool';
      if (kind === 'suspension') return category === 'suspension' || category === 'steering' || category === 'drivetrain' || category === 'chassis';
      return !!category;
    }
    if (kind === 'wheels') return !!(WHEELS_ALLOWED[handle] || WHEELS_ALLOWED[family]);
    if (kind === 'electronics') return !!(ELECTRONICS_ALLOWED[handle] || ELECTRONICS_ALLOWED[family]);
    if (kind === 'tools') return !!(TOOLS_ALLOWED[handle] || TOOLS_ALLOWED[family]);
    if (kind === 'suspension') return !!(SUSPENSION_ALLOWED[handle] || SUSPENSION_ALLOWED[family]);
    if (kind === 'brand') return !!(BRAND_ALLOWED[handle] || BRAND_ALLOWED[family]);
    return !!(GENERAL_ALLOWED[handle] || GENERAL_ALLOWED[family]);
  }

  var ROUTE_MAP = {
    receiver: ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'RC Radio Systems'],
    receivers: ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'RC Radio Systems'],
    'receiver-box': ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'Receiver Box'],
    'receiver-boxes': ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'Receiver Box'],
    radio: ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'Radio'],
    radios: ['radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters', 'Radio'],
    esc: ['electronic-speed-controls-accessories-for-rc-cars-boats-planes-helicopters', 'ESC'],
    escs: ['electronic-speed-controls-accessories-for-rc-cars-boats-planes-helicopters', 'ESC'],
    servo: ['servos-digital-servos-for-rc-cars-boats-planes-helicopters', 'Servo'],
    servos: ['servos-digital-servos-for-rc-cars-boats-planes-helicopters', 'Servo'],
    'servo-horn': ['aluminum-servo-horn-for-rc-cars-boats-planes-helicopters', 'Servo Horn'],
    'servo-horns': ['aluminum-servo-horn-for-rc-cars-boats-planes-helicopters', 'Servo Horn'],
    connector: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Connector'],
    connectors: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Connector'],
    plug: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Plug'],
    plugs: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Plug'],
    wire: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Wire'],
    wires: ['connectors-plugs-wires-for-rc-cars-helicopters-planes', 'Wire'],
    battery: ['battery-plugs-meters-accessories-for-rc-cars-boats-planes-helicopters', 'Battery'],
    batteries: ['battery-plugs-meters-accessories-for-rc-cars-boats-planes-helicopters', 'Battery']
  };

  function optionUrl(base, tags, handle, active) {
    base = handleize(base);
    handle = handleize(handle);
    var next = active ? tagsWithout(tags, handle) : unique(tagsWithout(tags, handle).concat([handle]));
    if (!active && base === 'rc-electronics' && ROUTE_MAP[handle]) {
      var extras = next.filter(function (tag) { return canonical(tag) !== canonical(handle); });
      return buildUrl(ROUTE_MAP[handle][0], extras);
    }
    return buildUrl(base, next);
  }

  var assetBase = window.INTEGY_FILTER_INDEX_ASSET_BASE || '';
  var indexPromises = Object.create(null);

  function indexUrl(handle) {
    return assetBase + 'integy-filter-index-' + encodeURIComponent(handle) + '.json';
  }

  function addIndexCandidate(values, handle) {
    handle = handleize(handle);
    if (handle) values.push(handle);
  }

  function modelIndexCandidates(handle) {
    var values = [];
    var original = handleize(handle);
    var brandPrefixes = [
      'hop-up-parts-for-arrma-', 'hopups-for-arrma-', 'parts-for-arrma-', 'arrma-',
      'hop-up-parts-for-traxxas-', 'hopups-for-traxxas-', 'parts-for-traxxas-', 'traxxas-',
      'hop-up-parts-for-losi-', 'hopups-for-losi-', 'parts-for-losi-', 'losi-',
      'hop-up-parts-for-axial-', 'hop-up-parts-for-axial-adventure-', 'hopups-for-axial-', 'parts-for-axial-', 'axial-',
      'hop-up-parts-for-hpi-racing-', 'hopups-for-hpi-racing-', 'parts-for-hpi-', 'hpi-racing-', 'hpi-',
      'hop-up-parts-for-tamiya-', 'hopups-for-tamiya-', 'parts-for-tamiya-', 'tamiya-',
      'hop-up-parts-for-associated-', 'hopups-for-associated-', 'associated-',
      'hop-up-parts-for-kyosho-', 'hopups-for-kyosho-', 'kyosho-'
    ];
    brandPrefixes.forEach(function (prefix) {
      if (original.indexOf(prefix) === 0 && original.length > prefix.length + 2) {
        var model = original.slice(prefix.length);
        addIndexCandidate(values, model);
        addIndexCandidate(values, model.replace(/^(arrma|traxxas|losi|axial|hpi|hpi-racing|tamiya|associated|kyosho)-/, ''));
      }
    });
    var familyMatches = original.match(/(kraton|outcast|felony|infraction|mojave|typhon|talion|senton|granite|vorteks|slash|trx-4|x-maxx|t-maxx|e-maxx|rustler|stampede|bandit|maxx|summit|revo|dbxl|mini-t|baja|scx10|capra|yeti|wraith|scx24)/g);
    (familyMatches || []).forEach(function (match) { addIndexCandidate(values, match); });
    return unique(values);
  }

  function indexCandidates(handle) {
    handle = handleize(handle);
    var values = BRAND_COLLECTIONS[handle] ? [] : modelIndexCandidates(handle);
    addIndexCandidate(values, handle);
    var aliases = {
      'hopups-for-arrma': 'hop-up-parts-for-arrma',
      'hopups-for-losi': 'hop-up-parts-for-losi',
      'hopups-for-axial': 'hop-up-parts-for-axial-adventure',
      'hopups-for-hpi-racing': 'hop-up-parts-for-hpi-racing',
      'hopups-for-tamiya': 'hop-up-parts-for-tamiya',
      'hopups-for-traxxas': 'hop-up-parts-for-traxxas',
      'radio-controllers-tx-receivers-for-rc-cars-boats-planes-helicopters': 'radio-controllers-tx-receivers-boats-planes-helicopters',
      'electronic-speed-controls-accessories-for-rc-cars-boats-planes-helicopters': 'esc',
      'servos-digital-servos-for-rc-cars-boats-planes-helicopters': 'servos',
      'battery-plugs-meters-accessories-for-rc-cars-boats-planes-helicopters': 'battery',
      products: 'all'
    };
    if (aliases[handle]) addIndexCandidate(values, aliases[handle]);
    return unique(values);
  }

  function fetchIndexCandidate(handles, position) {
    if (position >= handles.length) return Promise.resolve(null);
    var handle = handles[position];
    return fetch(indexUrl(handle), {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('filter index unavailable');
      return response.json();
    }).then(function (data) {
      if (data && data.tags) {
        data.__v295Handle = handle;
        return data;
      }
      return fetchIndexCandidate(handles, position + 1);
    }).catch(function () {
      return fetchIndexCandidate(handles, position + 1);
    });
  }

  function loadIndex(handle) {
    handle = handleize(handle);
    if (!handle) return Promise.resolve(null);
    if (!indexPromises[handle]) {
      indexPromises[handle] = fetchIndexCandidate(indexCandidates(handle), 0);
    }
    return indexPromises[handle];
  }

  function range(count) {
    var output = [];
    for (var index = 0; index < Math.max(0, Number(count) || 0); index += 1) output.push(index);
    return output;
  }

  function makeSet(values) {
    var set = Object.create(null);
    (values || []).forEach(function (value) { set[value] = true; });
    return set;
  }

  function intersect(values, set) {
    return (values || []).filter(function (value) { return !!set[value]; });
  }

  function intersectionCount(values, set) {
    var count = 0;
    (values || []).forEach(function (value) { if (set[value]) count += 1; });
    return count;
  }

  function matchingIds(index, tags, exceptFamily) {
    if (!index || !index.tags) return { confirmed: false, ids: [] };
    var ids = range(index.count || 0);
    var confirmed = true;
    unique(tags).forEach(function (tag) {
      var family = canonical(tag);
      if (exceptFamily && family === exceptFamily) return;
      var values = v302Taxonomy && CANONICAL_GROUPS[family] ? familyValues(index, family) : index.tags[tag];
      if (!values) {
        confirmed = false;
        ids = [];
        return;
      }
      ids = intersect(ids, makeSet(values));
    });
    return { confirmed: confirmed, ids: ids };
  }

  function familyAliases(family) {
    family = canonical(family);
    var group = CANONICAL_GROUPS[family];
    return unique([family].concat(group && group.preferred || [], group && group.aliases || []));
  }

  function familyExcludeMap(family) {
    family = canonical(family);
    return makeMap(CANONICAL_GROUPS[family] && CANONICAL_GROUPS[family].exclude || []);
  }

  function usableFamilyAlias(handle, family) {
    handle = handleize(handle);
    var blocked = familyExcludeMap(family);
    var parts = handle.split('-');
    for (var index = 0; index < parts.length; index += 1) {
      if (blocked[parts[index]]) return false;
    }
    return true;
  }

  function excludedFamilyIds(index, family) {
    if (!index || !index.tags) return Object.create(null);
    var blocked = Object.create(null);
    var group = CANONICAL_GROUPS[canonical(family)];
    (group && group.exclude || []).forEach(function (handle) {
      familyAliases(handle).forEach(function (alias) {
        (index.tags[alias] || []).forEach(function (id) {
          blocked[id] = true;
        });
      });
    });
    return blocked;
  }

  function familyValues(index, family) {
    if (!index || !index.tags) return [];
    var seen = Object.create(null);
    var blocked = excludedFamilyIds(index, family);
    var values = [];
    familyAliases(family).forEach(function (alias) {
      if (!usableFamilyAlias(alias, family)) return;
      (index.tags[alias] || []).forEach(function (id) {
        if (!seen[id] && !blocked[id]) {
          seen[id] = true;
          values.push(id);
        }
      });
    });
    return values;
  }

  function preferredFamilyHandle(index, family, baseIds, fallback) {
    family = canonical(family);
    fallback = handleize(fallback) || family;
    var aliases = familyAliases(family);
    var baseSet = makeSet(baseIds || []);
    var best = fallback;
    var bestCount = -1;
    aliases.forEach(function (alias) {
      if (!usableFamilyAlias(alias, family)) return;
      var values = index && index.tags && index.tags[alias];
      if (!values || !values.length) return;
      var count = baseIds && baseIds.length ? intersectionCount(values, baseSet) : values.length;
      if (count > bestCount || (count === bestCount && alias === family)) {
        best = alias;
        bestCount = count;
      }
    });
    return best;
  }

  function labelFor(index, handle) {
    var group = CANONICAL_GROUPS[canonical(handle)];
    if (group && group.label) return group.label;
    var label = clean(index && index.labels && index.labels[handle]);
    return label || titleize(handle);
  }

  function optionRank(handle, group) {
    var order = group === 'color'
      ? ['black', 'blue', 'red', 'silver', 'green', 'orange', 'purple', 'gold', 'yellow', 'gunmetal', 'grey', 'white', 'clear', 'pink', 'bronze', 'chrome', 'titanium']
      : ['rod-end', 'tie-rod', 'turnbuckle', 'linkage', 'suspension-link', 'steering-link', 'camber-link', 'shock', 'shock-shaft', 'shock-spring', 'shock-tower', 'shock-cap', 'suspension-arm', 'arm-mount', 'hinge-pin', 'hub-carrier', 'caster-block', 'knuckle', 'steering-block', 'servo-horn', 'servo-saver', 'gear', 'pinion-gear', 'spur-gear', 'gear-set', 'gearbox', 'differential', 'drive-shaft', 'axle', 'drive-cup', 'outdrive', 'bearing', 'wheel', 'tire', 'wheel-hex', 'wheel-nut', 'wheel-adapter', 'foam-insert', 'beadlock-ring', 'chassis', 'chassis-brace', 'skid-plate', 'bumper', 'body-mount', 'roll-cage', 'wing-mount', 'battery-tray', 'battery-plate', 'motor-mount', 'hex-wrench', 'nut-driver', 'screwdriver', 'tool-tip', 'shock-tool', 'setup-station', 'led-light', 'light-bar', 'receiver-box', 'esc', 'motor', 'servo', 'fan', 'connector', 'plug', 'wire', 'battery', 'charger'];
    var position = order.indexOf(canonical(handle));
    return position >= 0 ? position : 999;
  }

  function supplementalCandidates(base, kind) {
    var map = Object.create(null);
    base = handleize(base);
    if (kind !== 'brand' && !brandName()) return map;
    if (!/(arrma|traxxas|losi|axial|hpi|tamiya|associated|kyosho|kraton|slash|trx|x-maxx|dbxl|scx10|baja|mini-t)/.test(base)) return map;
    MODEL_PART_PROBES.forEach(function (handle) { map[handle] = true; });
    return map;
  }

  function normalizedIndexCandidates(index, tags) {
    var seen = Object.create(null);
    var output = [];
    function add(handle) {
      handle = handleize(handle);
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      output.push(handle);
    }
    Object.keys(CANONICAL_GROUPS).forEach(function (family) {
      if (familyValues(index, family).length) add(family);
    });
    Object.keys(COLORS).forEach(function (color) {
      if (index && index.tags && index.tags[color] && index.tags[color].length) add(color);
    });
    unique(tags).forEach(add);
    var specialty = V439_SPECIALTY_ALLOWED[currentCollection()];
    if (specialty) Object.keys(specialty).forEach(add);
    return output;
  }

  function optionsFromIndex(index, base, tags) {
    var kind = collectionKind(base);
    var activeMap = Object.create(null);
    var activeFamilyMap = Object.create(null);
    unique(tags).forEach(function (tag) { activeMap[tag] = true; });
    unique(tags).forEach(function (tag) { activeFamilyMap[canonical(tag)] = tag; });
    var grouped = Object.create(null);
    var candidates = v302Taxonomy
      ? normalizedIndexCandidates(index, tags)
      : Object.keys((index && index.tags) || {});
    var supplemental = v302Taxonomy ? Object.create(null) : supplementalCandidates(base, kind);
    Object.keys(supplemental).forEach(function (handle) {
      if (candidates.indexOf(handle) === -1) candidates.push(handle);
    });

    unique(tags).forEach(function (tag) {
      if (candidates.indexOf(tag) === -1) candidates.push(tag);
    });

    candidates.forEach(function (rawHandle) {
      var handle = handleize(rawHandle);
      var family = canonical(handle);
      var active = !!activeMap[handle] || !!activeFamilyMap[family];
      if (!allowed(handle, kind, active)) return;
      var baseMatch = matchingIds(index, tags, active ? family : '');
      var values = familyValues(index, family);
      var liveProbe = ((!v302Taxonomy && !!(supplemental[handle] || supplemental[family])) ||
        (kind === 'specialty' && v439SpecialtyAllowed(handle))) && !values.length && !active;
      var count = 0;
      var confirmed = baseMatch.confirmed;

      if (active) {
        count = baseMatch.ids.length;
      } else if (values.length && baseMatch.confirmed) {
        count = intersectionCount(values, makeSet(baseMatch.ids));
      } else if (liveProbe) {
        confirmed = false;
      } else {
        confirmed = false;
      }

      if (!active && confirmed && count <= 0) return;
      if (!active && !confirmed && !liveProbe) return;

      var hrefHandle = active ? (activeFamilyMap[family] || handle) : preferredFamilyHandle(index, family, baseMatch.ids, handle);
      var group = COLORS[handle] || COLORS[family] ? 'color' : 'part';
      var option = {
        handle: hrefHandle,
        family: family,
        label: ROUTE_MAP[hrefHandle] && base === 'rc-electronics' ? ROUTE_MAP[hrefHandle][1] : labelFor(index, family),
        active: active,
        count: count,
        confirmed: confirmed,
        group: group,
        rank: optionRank(family, group),
        href: optionUrl(base, tags, hrefHandle, active)
      };

      var existing = grouped[group + '|' + family];
      if (!existing || option.active || (!existing.active && option.rank < existing.rank) ||
          (!existing.active && option.handle === option.family && existing.handle !== existing.family)) {
        grouped[group + '|' + family] = option;
      }
    });

    var output = { part: [], color: [] };
    Object.keys(grouped).forEach(function (key) {
      output[grouped[key].group].push(grouped[key]);
    });
    ['part', 'color'].forEach(function (group) {
      output[group].sort(function (a, b) {
        var left = clean(a.label), right = clean(b.label);
        try { return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base', ignorePunctuation: true }); }
        catch (error) { return left.localeCompare(right); }
      });
    });
    return output;
  }

  var localOptionsMemory = Object.create(null);
  var verifiedOptionsMemory = Object.create(null);

  function optionsCacheKey(base, tags) {
    return handleize(base) + '|' + unique(tags).sort().join('+');
  }

  function localOptionsFor(base, tags) {
    base = handleize(base);
    tags = unique(tags);
    var key = optionsCacheKey(base, tags);
    if (localOptionsMemory[key]) return localOptionsMemory[key];
    localOptionsMemory[key] = loadIndex(base).then(function (index) {
      return {
        base: base,
        tags: tags,
        index: index,
        normalized: v302Taxonomy,
        options: optionsFromIndex(index, base, tags)
      };
    });
    return localOptionsMemory[key];
  }

  var availabilityMemory = Object.create(null);
  var availabilityStorageKey = 'integy-v298-availability-v1';
  var availabilityStored = Object.create(null);
  try { availabilityStored = JSON.parse(sessionStorage.getItem(availabilityStorageKey) || '{}') || Object.create(null); } catch (error) {}

  function saveAvailability() {
    try { sessionStorage.setItem(availabilityStorageKey, JSON.stringify(availabilityStored)); } catch (error) {}
  }

  function htmlHasProducts(html) {
    html = String(html || '');
    var lower = html.toLowerCase();
    if (!lower || /no products matching your search|no products found|\b0\s+products?\b|data-product-count=["']0["']/.test(lower)) return false;
    var count = html.match(/(?:data-integy-result-count|data-product-count|collection--product-count|productgrid--count)[^>]*>\s*([0-9][0-9,]*)/i);
    if (count) return parseInt(count[1].replace(/,/g, ''), 10) > 0;
    // Count only collection-grid product cards. Header, menu, recently-viewed, and footer
    // product links must never make a zero-result tag route look available.
    return /(?:class=["'][^"']*(?:productgrid--item|productitem)[^"']*["']|data-product-item(?:=|\s|>)|data-product-card(?:=|\s|>))/i.test(html);
  }

  function verifyUrl(url) {
    var absolute;
    try { absolute = new URL(url, location.origin).href; } catch (error) { absolute = String(url || ''); }
    if (!absolute) return Promise.resolve(false);
    var requestedPath = '';
    try { requestedPath = new URL(absolute).pathname.replace(/\/+$/, ''); } catch (error) {}
    if (Object.prototype.hasOwnProperty.call(availabilityStored, absolute)) {
      return Promise.resolve(!!availabilityStored[absolute]);
    }
    if (availabilityMemory[absolute]) return availabilityMemory[absolute];
    availabilityMemory[absolute] = fetch(absolute, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) return false;
      try {
        var finalPath = new URL(response.url || absolute, location.origin).pathname.replace(/\/+$/, '');
        if (requestedPath && finalPath && finalPath !== requestedPath) return false;
      } catch (error) {}
      return response.text().then(htmlHasProducts);
    }).catch(function () {
      return false;
    }).then(function (available) {
      availabilityStored[absolute] = !!available;
      saveAvailability();
      return !!available;
    });
    return availabilityMemory[absolute];
  }

  function modelRows() {
    var seen = Object.create(null);
    return qsa('[data-integy-static-model-filter-row]').map(function (row) {
      var href = row.getAttribute('href') || '';
      var data = pathData(href);
      var label = clean(row.getAttribute('data-integy-v188-label') || row.getAttribute('title') || row.textContent);
      var key = data.collection + '|' + label;
      if (!data.collection || !label || seen[key]) return null;
      seen[key] = true;
      return {
        row: row,
        label: label,
        target: data.collection,
        href: href,
        active: data.collection === currentCollection() || row.getAttribute('aria-checked') === 'true'
      };
    }).filter(Boolean);
  }

  function verifyModelOption(option, tags) {
    if (option.active) return Promise.resolve(true);
    tags = unique(tags);
    var url = buildUrl(option.target, tags);
    return loadIndex(option.target).then(function (index) {
      if (index && index.tags) {
        var match = matchingIds(index, tags, '');
        if (v302Taxonomy) return match.confirmed && match.ids.length > 0;
        if (match.confirmed && match.ids.length <= 0) return false;
      }
      if (v302Taxonomy) return false;
      /* A positive local index is only a candidate. V295 live-confirms it because
         stale or over-broad indexes were the source of the V294 false positives. */
      return verifyUrl(url);
    });
  }

  function runLimited(items, limit, worker) {
    var output = new Array(items.length);
    var position = 0;
    var active = 0;
    return new Promise(function (resolve) {
      function next() {
        if (position >= items.length && active === 0) {
          resolve(output);
          return;
        }
        while (active < limit && position < items.length) {
          (function (slot) {
            position += 1;
            active += 1;
            Promise.resolve(worker(items[slot], slot)).then(function (value) {
              output[slot] = value;
            }).catch(function () {
              output[slot] = false;
            }).then(function () {
              active -= 1;
              next();
            });
          })(position);
        }
      }
      next();
    });
  }

  function verifyCanonicalOption(option, base, tags) {
    if (option.active) return Promise.resolve(true);
    return verifyUrl(option.href).then(function (available) {
      if (available) return true;
      var family = canonical(option.family || option.handle);
      if (!CANONICAL_GROUPS[family]) return false;
      var kind = collectionKind(base);
      var aliases = familyAliases(family).filter(function (alias) {
        alias = handleize(alias);
        return alias && alias !== option.handle && usableFamilyAlias(alias, family) && allowed(alias, kind, false);
      });
      var index = 0;
      function nextAlias() {
        if (index >= aliases.length) return Promise.resolve(false);
        var alias = aliases[index];
        index += 1;
        var href = optionUrl(base, tags, alias, false);
        if (href === option.href) return nextAlias();
        return verifyUrl(href).then(function (ok) {
          if (!ok) return nextAlias();
          option.handle = alias;
          option.href = href;
          option.liveVerified = true;
          return true;
        });
      }
      return nextAlias();
    });
  }

  function verifyOptionResult(result) {
    if (v302Taxonomy && result && result.normalized && !v439SpecialtyCollection()) return Promise.resolve(result);
    var groups = ['part', 'color'];
    var candidates = [];
    groups.forEach(function (group) {
      (result.options[group] || []).forEach(function (option) {
        candidates.push({ group: group, option: option });
      });
    });

    return deferWork(function () {
      return runLimited(candidates, lowPower ? 3 : 6, function (candidate) {
        if (candidate.option.active) return true;
        if (v439SpecialtyCollection() && candidate.option.confirmed && candidate.option.count > 0) return true;
        return verifyCanonicalOption(candidate.option, result.base, result.tags);
      });
    }).then(function (checks) {
      checks = Array.isArray(checks) ? checks : [];
      var verified = { part: [], color: [] };
      candidates.forEach(function (candidate, index) {
        if (candidate.option.active || checks[index]) {
          candidate.option.liveVerified = true;
          verified[candidate.group].push(candidate.option);
        }
      });
      return {
        base: result.base,
        tags: result.tags,
        index: result.index,
        normalized: result.normalized,
        options: verified
      };
    });
  }

  function optionsFor(base, tags) {
    var key = optionsCacheKey(base, tags);
    if (!verifiedOptionsMemory[key]) {
      verifiedOptionsMemory[key] = localOptionsFor(base, tags).then(verifyOptionResult);
    }
    return verifiedOptionsMemory[key];
  }

  function modelOptionsFor(tags) {
    var rows = modelRows();
    return deferWork(function () {
      return runLimited(rows, lowPower ? 3 : 6, function (option) {
        return verifyModelOption(option, tags);
      });
    }).then(function (checks) {
      checks = Array.isArray(checks) ? checks : [];
      return rows.filter(function (option, index) {
        return option.active || checks[index];
      }).map(function (option) {
        var copy = {};
        Object.keys(option).forEach(function (key) { if (key !== 'row') copy[key] = option[key]; });
        copy.href = option.active
          ? buildUrl(brandRoot(), tags)
          : buildUrl(option.target, tags);
        return copy;
      });
    });
  }

  function makePartRow(option) {
    var row = document.createElement('a');
    row.className = 'integy-v27-filter-chip integy-v31-checkbox-filter integy-v201-static-filter-row integy-v218-static-filter-row integy-v294-filter-row' +
      (option.direct ? ' integy-v439-direct-filter-link' : '') +
      (option.active ? ' is-active integy-v31-checkbox-filter--active' : '');
    row.href = option.href;
    row.setAttribute('role', 'checkbox');
    row.setAttribute('aria-checked', option.active ? 'true' : 'false');
    row.setAttribute('data-tag-handle', option.handle);
    row.setAttribute('data-integy-v294-filter-row', '');
    row.setAttribute('data-integy-v294-direct-nav', '');
    if (option.direct) {
      row.setAttribute('data-integy-v439-direct-filter', '');
      row.setAttribute('data-integy-v439-profile-key', option.handle);
    }
    row.innerHTML =
      '<span class="integy-v201-filter-box integy-v200-filter-box" aria-hidden="true"></span>' +
      '<span class="integy-v201-filter-label"></span>';
    qs('.integy-v201-filter-label', row).textContent = option.label;
    return row;
  }

  function renderPartOptions(result, pending) {
    var list = qs('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list');
    if (!list) return;

    var all = result.options.part.concat(result.options.color);
    var direct = V439_SPECIALTY_DIRECT[currentCollection()] || [];
    if (direct.length) {
      var existing = makeMap(all.map(function(option){ return option.handle; }));
      direct.slice().reverse().forEach(function(option){
        if (!existing[handleize(option.handle)]) {
          all.unshift({
            handle: option.handle,
            label: option.label,
            href: option.href,
            active: false,
            direct: true
          });
        }
      });
    }
    all.sort(function (a, b) {
      var left = clean(a.label), right = clean(b.label);
      try { return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base', ignorePunctuation: true }); }
      catch (error) { return left.localeCompare(right); }
    });
    var fragment = document.createDocumentFragment();
    all.forEach(function (option) { fragment.appendChild(makePartRow(option)); });
    if (pending) {
      var checking = document.createElement('span');
      checking.className = 'integy-v294-empty-note integy-v295-checking-note';
      checking.textContent = '';
      fragment.appendChild(checking);
    }
    list.innerHTML = '';
    if (all.length) {
      list.appendChild(fragment);
    } else if (pending) {
      list.appendChild(fragment);
    } else {
      var empty = document.createElement('span');
      empty.className = 'integy-v294-empty-note';
      empty.textContent = result.tags.length ? 'No additional matching filters.' : 'No matching part filters are available.';
      list.appendChild(empty);
    }
    if (pending) {
      list.removeAttribute('data-integy-v294-ready');
      list.setAttribute('data-integy-v295-state', 'checking');
      list.setAttribute('data-integy-v297-state', 'checking');
      list.setAttribute('data-integy-v298-state', 'checking');
    } else {
      list.setAttribute('data-integy-v294-ready', 'true');
      list.setAttribute('data-integy-v295-state', 'ready');
      list.setAttribute('data-integy-v297-state', 'ready');
      list.setAttribute('data-integy-v298-state', 'ready');
    }
    list.setAttribute('data-integy-v294-owner', 'true');
  }

  function prepareModelRows() {
    var group = qs('[data-integy-static-model-filter-group]');
    var rows = modelRows();
    if (!group || !rows.length) return Promise.resolve([]);
    group.setAttribute('data-integy-v294-state', 'checking');

    rows.forEach(function (option) {
      option.row.setAttribute('data-integy-v294-candidate', '');
      option.row.removeAttribute('data-integy-v294-ready');
      if (option.active) {
        option.row.href = buildUrl(brandRoot(), currentTags());
        option.row.setAttribute('data-integy-v294-direct-nav', '');
        option.row.setAttribute('data-integy-v294-ready', 'true');
      }
    });

    return deferWork(function () {
      return runLimited(rows, lowPower ? 3 : 6, function (option) {
        return verifyModelOption(option, currentTags());
      });
    }).then(function (checks) {
      checks = Array.isArray(checks) ? checks : [];
      var available = [];
      rows.forEach(function (option, index) {
        var show = option.active || checks[index];
        option.row.classList.toggle('integy-v294-zero-hidden', !show);
        option.row.setAttribute('data-integy-v294-ready', 'true');
        option.row.setAttribute('data-integy-v294-available', show ? 'true' : 'false');
        option.row.setAttribute('data-integy-v294-direct-nav', '');
        if (show) available.push(option);
      });
      group.setAttribute('data-integy-v294-state', 'ready');
      group.setAttribute('data-integy-v294-visible-count', String(available.length));
      if (!available.length) group.classList.add('integy-v294-zero-hidden');
      return available;
    });
  }

  function directFilterNavigation(event) {
    var anchor = event.target && event.target.closest
      ? event.target.closest('a[data-integy-v294-direct-nav]')
      : null;
    if (!anchor || !anchor.href || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    location.assign(anchor.href);
  }

  var state = {
    base: currentCollection(),
    tags: currentTags(),
    brand: brandName(),
    brandRoot: '',
    modelOptions: [],
    partOptions: [],
    colorOptions: []
  };
  state.brandRoot = brandRoot();

  var readyResolve;
  var readyPromise = new Promise(function (resolve) { readyResolve = resolve; });

  function render() {
    // INTEGY V443: LED Lights uses a server-rendered, live-tag-validated profile.
    // Its legacy per-tag index predates the current collection membership and must not
    // repopulate zero-result options after Liquid has removed them.
    if (state.base === 'led-lights') {
      var ledSidebar = qs('.productgrid--sidebar,[data-productgrid-sidebar]');
      if (ledSidebar) {
        ledSidebar.setAttribute('data-integy-v294-owner', 'true');
        ledSidebar.setAttribute('data-integy-v294-ready', 'true');
      }
      root.classList.add('integy-v294-filter-ready','integy-v295-filter-ready','integy-v297-filter-ready','integy-v298-filter-ready','integy-v443-led-profile-ready');
      if (v302Taxonomy) root.classList.add('integy-v302-filter-ready');
      readyResolve(state);
      return;
    }
    if (state.base === 'suspension-parts' || state.base === 'tesla-accessories') {
      root.classList.add('integy-v294-filter-ready','integy-v295-filter-ready','integy-v297-filter-ready','integy-v298-filter-ready','integy-v436-suspension-profile-ready');
      if (v302Taxonomy) root.classList.add('integy-v302-filter-ready');
      readyResolve(state);
      return;
    }
    if (!document.body || !document.body.classList.contains('template-collection') || !state.base) {
      root.classList.add('integy-v294-filter-ready', 'integy-v295-filter-ready', 'integy-v297-filter-ready', 'integy-v298-filter-ready');
      if (v302Taxonomy) root.classList.add('integy-v302-filter-ready');
      readyResolve(state);
      return;
    }

    var sidebar = qs('.productgrid--sidebar,[data-productgrid-sidebar]');
    if (sidebar) sidebar.setAttribute('data-integy-v294-owner', 'true');
    var partList = qs('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list');
    if (partList) {
      partList.removeAttribute('data-integy-v294-ready');
      partList.setAttribute('data-integy-v295-state', 'checking');
      partList.setAttribute('data-integy-v298-state', 'checking');
    }

    Promise.all([
      localOptionsFor(state.base, state.tags).then(function (localResult) {
        if (localResult.normalized) return localResult;
        var activeOnly = {
          base: localResult.base,
          tags: localResult.tags,
          options: {
            part: localResult.options.part.filter(function (option) { return option.active; }),
            color: localResult.options.color.filter(function (option) { return option.active; })
          }
        };
        renderPartOptions(activeOnly, true);
        return verifyOptionResult(localResult);
      }).then(function (result) {
        renderPartOptions(result);
        state.partOptions = result.options.part;
        state.colorOptions = result.options.color;
      }),
      prepareModelRows().then(function (models) {
        state.modelOptions = models;
      })
    ]).then(function () {
      root.classList.add('integy-v294-filter-ready', 'integy-v295-filter-ready', 'integy-v297-filter-ready', 'integy-v298-filter-ready');
      if (v302Taxonomy) root.classList.add('integy-v302-filter-ready');
      if (sidebar) sidebar.setAttribute('data-integy-v294-ready', 'true');
      readyResolve(state);
      try {
        document.dispatchEvent(new CustomEvent('integy:v295:filters-ready', { detail: state }));
        document.dispatchEvent(new CustomEvent('integy:v297:filters-ready', { detail: state }));
        document.dispatchEvent(new CustomEvent('integy:v298:filters-ready', { detail: state }));
      } catch (error) {}
    });
  }

  var api = {
    ready: readyPromise,
    getState: function () { return state; },
    optionsFor: optionsFor,
    modelOptionsFor: modelOptionsFor,
    buildUrl: buildUrl,
    brandRoot: brandRoot,
    currentCollection: currentCollection,
    currentTags: currentTags,
    canonical: canonical,
    aliasGroups: CANONICAL_GROUPS,
    isColor: function (handle) { return !!COLORS[handleize(handle)]; },
    verifyUrl: verifyUrl
  };
  window.IntegyV298Filters = api;
  window.IntegyV297Filters = api;
  window.IntegyV295Filters = api;

  document.addEventListener('click', directFilterNavigation, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render, { once: true });
  } else {
    render();
  }
})();
